import React, { Component } from 'react';
import './SelectCarCardMobile.css';
import FaCalendar from 'react-icons/lib/fa/calendar';
import FaAutomobile from 'react-icons/lib/fa/automobile';
import FaExternalLink from 'react-icons/lib/fa/external-link';
import FaCheck from 'react-icons/lib/fa/check';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { getTranslate } from 'react-localize-redux';
import { formValueSelector } from 'redux-form';
import creditCards from '../../assets/images/creditcards.png';

class SelectedCarCardMobile extends Component {
  render() {

    const {
      vehicleCategoryName,
      translate,
      issueDateDiff,
      dayType,
      startDate,
      endDate,
      premium,
      canPay,
      isLoading,
      onClick,
    } = this.props;

    return (
      <div className="select-policy-reg-head-mobile">
        <div className="selected-red-head-item-mobile">
            <p className="mobile-Policy-item-top">{translate('transportCategory')}</p>
            <p className="mobile-Policy-item-bottom">{vehicleCategoryName ? translate(vehicleCategoryName) : '- - - -'}</p>
        </div>
        <div className="selected-red-head-item-mobile">
              <p className="mobile-Policy-item-top"> {translate('active')} {translate('period')}</p>
              <div className="mobile-Policy-item-bottom">
              {issueDateDiff ? issueDateDiff : '_ _'} {' '}
                {dayType ? translate(dayType) : '---'}
                <p className="mobile-Policy-item-date">
                  {startDate ? startDate.format('DD MMM YYYY') : '__/__/__'} {' '}
                  {endDate ? endDate.format('DD MMM YYYY') : '__/__/__'}
                </p>
              </div>
        </div>

        <div className="selected-red-head-item-mobile">
          <p className="mobile-Policy-item-top mobile-Policy-item-top-price">
              {translate('price')} {premium ? premium : '-' + '-'} ₾  
          </p>
        </div>
        
            {/* <a href="#" target="_blank" className="insurer-conditions-text">
                {translate('insuranceCondition')}  <FaExternalLink />
            </a> */
            }
        </div>
    );
  }
}
const selector = formValueSelector('CreatePolicyForm');

const mapStateToProps = state => {
  const startDate = selector(state, 'startDate');
  const endDate = selector(state, 'endDate');
  const issueDateDiff = selector(state, 'issueDateDiff');
  const dayType = selector(state, 'dayType');
  const vehicleCategoryName = selector(state, 'vehicleCategoryName');
  const premium = selector(state, 'premium');
  return {
    translate: getTranslate(state.locale),
    startDate,
    endDate,
    issueDateDiff,
    dayType,
    premium,
    vehicleCategoryName,
  };
};

export default connect(mapStateToProps)(SelectedCarCardMobile);



// WEBPACK FOOTER //
// ./src/components/Select-Car-Card-Mobile/SelectCarCardMobile.js